import { Button } from "../../button";
import { cn } from "../../utils";

export interface SmartView {
  id: number;
  slug: string;
  name: string;
  entity_kind: string;
}

export function SmartViewPicker({
  views,
  activeSlug,
  onSelect,
  onClear,
}: {
  views: SmartView[];
  activeSlug?: string | null;
  onSelect?: (slug: string) => void;
  onClear?: () => void;
}) {
  if (views.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button
        variant={activeSlug == null ? "default" : "outline"}
        size="sm"
        onClick={onClear}
      >
        All
      </Button>
      {views.map((v) => (
        <Button
          key={v.id}
          variant={activeSlug === v.slug ? "default" : "outline"}
          size="sm"
          className={cn("font-normal")}
          onClick={() => onSelect?.(v.slug)}
        >
          {v.name}
        </Button>
      ))}
    </div>
  );
}
